import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import config from 'utils/config';
import { AUTOMATIC, MANUAL } from 'utils/asset/markAsDoneModes';
import { checkIfScormSettingsWereChanged, checkIfSubtitlesWereChanged } from 'screens/AssetEditor/utils';
import DEFAULT_SCORM_SETTINGS from 'screens/ScormAdvancedSettingsModal/defaultScormSettings';
import useForm from 'hooks/useForm';
function getCommonFields(content) {
  return {
    thumbnailId: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.thumbnailId) || null;
      }
    },
    externalRefId: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.externalRefId) || '';
      }
    },
    ownerTeamId: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.ownerTeamId) || null;
      }
    },
    parentId: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.parentId) || null;
      }
    },
    markAsDoneMode: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.markAsDoneMode) || (config.manualMarkAsDone ? MANUAL : AUTOMATIC);
      }
    },
    owner: {
      getDefaultValue: function getDefaultValue() {
        return (content === null || content === void 0 ? void 0 : content.owner) || null;
      },
      getWasChanged: function getWasChanged(defaultValue, newValue) {
        var defaultOwnerId = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id) || null;
        var newOwnerId = (newValue === null || newValue === void 0 ? void 0 : newValue.id) || null;
        return defaultOwnerId !== newOwnerId;
      }
    }
  };
}
export function useAssetEditorForm(_ref) {
  var content = _ref.content,
    aiSuggestions = _ref.aiSuggestions,
    defaultLocale = _ref.defaultLocale;
  var commonFields = getCommonFields(content);
  return useForm({
    fields: _objectSpread(_objectSpread({}, commonFields), {}, {
      fileId: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.fileId) || '';
        }
      },
      name: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.name) || '';
        },
        required: true
      },
      description: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.description) || '';
        }
      },
      tags: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.tags) || [];
        }
      },
      customType: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.customType) || '';
        }
      },
      locale: {
        getDefaultValue: function getDefaultValue() {
          var detectedLocale = aiSuggestions.locale.status === 'ready' ? aiSuggestions.locale.value : null;
          return (content === null || content === void 0 ? void 0 : content.locale) || detectedLocale || defaultLocale;
        }
      },
      completionTime: {
        getDefaultValue: function getDefaultValue() {
          return Number(content === null || content === void 0 ? void 0 : content.completionTime) || 0;
        }
      },
      download: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.download) || 'disabled';
        }
      },
      // Required for image assets
      alternativeText: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.alternativeText) || '';
        }
      },
      // Required for editing web link assets
      webUrl: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.webUrl) || '';
        }
      },
      // Required for editing web link assets
      openInIframe: {
        getDefaultValue: function getDefaultValue() {
          return typeof (content === null || content === void 0 ? void 0 : content.openInIframe) !== 'undefined' ? content.openInIframe : true;
        }
      },
      // Required for video assets
      subtitles: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.subtitles) || [];
        },
        getWasChanged: checkIfSubtitlesWereChanged
      },
      // Required for scorm assets
      scormSettings: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.scormSettings) || DEFAULT_SCORM_SETTINGS;
        },
        getWasChanged: checkIfScormSettingsWereChanged
      },
      excludeFromAi: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.excludeFromAi) || false;
        }
      },
      excludedFromAiByParent: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.excludedFromAiByParent) || false;
        }
      }
    })
  });
}
export function useLinkEditorForm(_ref2) {
  var content = _ref2.content,
    aiSuggestions = _ref2.aiSuggestions,
    defaultLocale = _ref2.defaultLocale;
  var commonFields = getCommonFields(content);
  return useForm({
    fields: _objectSpread(_objectSpread({}, commonFields), {}, {
      name: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.name) || (content === null || content === void 0 ? void 0 : content.webUrl) || '';
        },
        required: true
      },
      description: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.description) || '';
        }
      },
      tags: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.tags) || [];
        }
      },
      customType: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.customType) || '';
        }
      },
      locale: {
        getDefaultValue: function getDefaultValue() {
          var detectedLocale = aiSuggestions.locale.status === 'ready' ? aiSuggestions.locale.value : null;
          return (content === null || content === void 0 ? void 0 : content.locale) || detectedLocale || defaultLocale;
        }
      },
      completionTime: {
        getDefaultValue: function getDefaultValue() {
          return Number(content === null || content === void 0 ? void 0 : content.completionTime) || 0;
        }
      },
      webUrl: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.webUrl) || '';
        },
        required: true
      },
      openInIframe: {
        getDefaultValue: function getDefaultValue() {
          return typeof (content === null || content === void 0 ? void 0 : content.openInIframe) !== 'undefined' ? content === null || content === void 0 ? void 0 : content.openInIframe : true;
        }
      },
      excludeFromAi: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.excludeFromAi) || false;
        }
      },
      excludedFromAiByParent: {
        getDefaultValue: function getDefaultValue() {
          return (content === null || content === void 0 ? void 0 : content.excludedFromAiByParent) || false;
        }
      }
    })
  });
}